import { render } from "./ProcessTabs.vue?vue&type=template&id=2688da1e&scoped=true"
import script from "./ProcessTabs.vue?vue&type=script&lang=js"
export * from "./ProcessTabs.vue?vue&type=script&lang=js"

import "./ProcessTabs.vue?vue&type=style&index=0&id=2688da1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2688da1e"]])

export default __exports__